import styled from 'styled-components';
import { BodyLarge, BodyMedium400, TitleMedium500, TitleXLarge } from '@nebula/global-styles';
import Button from '@nebula/button';

export const SuccessContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  margin: 0 1rem;
`;

export const SuccessText = styled(TitleMedium500)`
  margin: 0.5rem 0;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    ${TitleXLarge}
  }
`;

export const SuccessMessage = styled(BodyMedium400)`
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    ${BodyLarge}
  }
`;

export const StyledButton = styled(Button)`
  height: 2.5rem;
  margin: 1rem 0;
`;
